<template>
    <div>
        <keep-alive>
        <router-view></router-view>
        </keep-alive>
    </div>
</template>
<script>
// 用于自定义菜单
export default {
    name: `TransferLayout`,
    props: {},
    data() {
        return {
            title: `患者转运父级页面`
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Mobile/Transfer/Layout.vue